import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import PersonForm from './person-form.js'

import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools.js'

export default {
  name: 'CrmDetailsPerson',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    boardArchived: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: {},
      form: PersonForm,
      associate: null
    }
  },
  watch: {
    card () {
      if (this.card && this.card.pessoa) {
        this.onSyncData()
      }
    }
  },
  computed: {
    personType: function () {
      let result = 'PF'
      if (this.card && this.card.pessoa && this.card.pessoa.tipoPessoa) {
        return this.card.pessoa.tipoPessoa
      } else {
        result = 'PF'
        if (this.card && this.card.pessoa && this.card.pessoa.document) {
          let doc = this.card.pessoa.document.replace('.', '')
          doc = doc.replace('.', '')
          doc = doc.replace('-', '')
          doc = doc.replace('/', '')

          if (doc.length > 11) {
            result = 'PJ'
          }
        }
      }
      return result
    }
  },
  mounted () {
    this.onGetAllOrigin()
  },
  methods: {
    onLoad () {},
    onSyncData () {
      this.form.name.value = this.card.pessoa.nome
      this.form.document.value = this.card.pessoa.document
      if (this.card.pessoa.dataNascimento) {
        this.form.dataNascimento.value = this.card.pessoa.dataNascimento.split('T')[0].split('-').reverse().join('/')
      }
      this.form.tipoPessoa.value = this.card.pessoa.tipoPessoa ? this.card.pessoa.tipoPessoa : this.personType
      this.form.leadOriginID.value = this.card.origemLead ? this.card.origemLead.id : null
      this.onLoadAssociate(this.card.pessoa.document)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    async onLoadAssociate (document) {
      if (document) {
        loading.push()
        await AssociateRepository.Search('document=' + this.card.pessoa.document, 1, 0)
          .then((response) => {
            loading.close()
            var data = response.data.content
            if (data && data.length > 0) {
              this.associate = data[0]
              if (this.associate) {
                this.form.numId.value = this.associate.numId
                return
              }
            }
            this.form.numId.value = null
          })
          .catch(this.onException)
      }
    },
    onGetAllOrigin () {
      loading.push()
      OriginRepository.GetAll()
        .then((response) => {
          this.form.leadOriginID.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    async onUpdate () {
      await this.onUpdatePerson(this.card.pessoa)
    },
    async onUpdatePerson (pessoa) {
      if (pessoa) {
        loading.push()
        this.setPersonInData()
        PersonRepository.Patch(this.data)
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              createNewFollowupWithCard(this.card.pessoa.document, 'sys_atualizacao_cadastral', 'O cadastro de ' + pessoa.nomeAssociado + ' foi atualizado! ', this.ip, this.latitude, this.longitude, this.card.id)
              this.$emit('Reload')
            }
          })
          .catch(this.onException)
      }
    },
    setPersonInData () {
      this.data.id = this.card.pessoa.id
      if (this.form.name.value) { this.data.nome = this.form.name.value }
      if (this.form.dataNascimento.value) { this.data.dataNascimento = this.form.dataNascimento.value.split('/').reverse().join('-') }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/person/person.js